import { int } from '@/hooks/useUrlState';

/** The /tax-reports query string (see README "List pages, URL state"); the page size is fixed. */
export const taxReportsUrlSchema = {
  page: int({ min: 1 }, 1),
};
